import {
  ERROR_MESSAGES_MODELS,
  REGEX_MODELS,
} from "../Models/ValidationModels";

const REGEX: REGEX_MODELS = {
  EMAIL: new RegExp(
    "^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$"
  ),
  PASSWORD: new RegExp(
    "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])"
  ),
  COMMISSION_REGEX: new RegExp("^(d{1,2}(.d{1,2})?|100(.0{1,2})?)$"),
  PHONE_VALIDATION: new RegExp("^(?:\\+971|00971|0)?(?:2|3|4|6|7|9)\\d{7}$"),
  ENGLISH_INPUT_VALIDATION: new RegExp("^[a-zA-Z\\s]*$"), //"^[a-zA-Z0-9\\s]+$"
  ARABIC_INPUT_VALIDATION: new RegExp("^[\\u0600-\\u06FF\\s]+$"),
  DECIMAL_VALIDATION: new RegExp("^\\d+(\\.\\d*)?$"),
  DECIMAL_RESTRICTION: new RegExp(/^\d*\.?\d{0,2}$/),
  EMIRATES_ID: new RegExp(/^[0-9]{3}-?[0-9]{7}-?[0-9]{5}-?[0-9]$/),
  // IBAN_VALIDATION: new RegExp(/^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/),
  URL_VALIDATION: new RegExp(
    "((https?):\\/\\/)?(www\\.)?[a-z0-9]+(\\.[a-z]{2,}){1,3}(#?\\/?[a-zA-Z0-9#]+)*\\/?(\\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$"
  ),
};
const ERROR_MESSAGES: ERROR_MESSAGES_MODELS = {
  EMAIL_REQUIRED: "Please enter the E-Mail ID",
  AUTHORITY_EMAIL_REQUIRED: "Please enter the authority E-Mail ID",
  INVALID_EMAIL: "Please enter a valid E-mail ID",
  TUTOR_TYPE_REQUIRED: "Please select the tutor type",
  NAME_REQUIRED: "Please enter the name",
  PASSWORD_REQUIRED: "Please enter the password",
  CONFIRM_PASSWORD_REQUIRED: "Please enter the password",
  MINIMUM_PASSWORD: "Password should be more than 8 characters",
  MAXIMUM_PASSWORD: "Password should be less than 16 characters",
  INVALID_PASSWORD:
    "Password should contain at least 1 uppercase, 1 lowercase letter, 1 number, 1 special character",
  OLD_PASS_MSG: "Old Password should not be empty",
  NEW_PASS_MSG: "New Password should not be empty",
  CONF_PASS_MSG: "Confirm Password should not be empty",
  CATEGORY_NAME: "Course category name is required",
  ARABIC_CATEGORY_NAME: "Arabic Course category name is required",
  MAX_PRICE_MSG: "Maximum price is required",
  MIN_PRICE_MSG: "Minimum price is required",
  FIRST_NAME: "First Name is required",
  LAST_NAME: "Last Name is required",
  PHONE_NUMBER: "Phone Number is required",
  VALID_PHONE_NUMBER: "Please enter valid phone number",
  PHONE_NUMBER_FORMAT: "Invalid Phone number format",
  PASSWORD_MATCH: "New password and confirm password doesn't match",
  REGISTER_PASSWORD_MATCH: "Password doesn't match",
  MIN_MAX_MATCH: "Maximum price should be greater than minimum price",
  COMMISSION_ERR: "Commission percentage should not be greater than 100",
  TAG_VALIDATION: "Tag name already exists!",
  SKILL_VALIDATION: "Skill name already exists!",
  SPECIALIZATION_VALIDATION: "Specialization name already exists!",
  COMMISSION_REQUIRED: "Commission percentage is required",
  AMOUNT_FORMAT: "Please enter correct amount format",
  PERCENTAGE_FORMAT: "Please enter a correct percentage format",
  OTP_MESSAGE: "Please enter OTP",
  PHONE_INPUT: "Please enter valid phone number",
  SESSION_TOTAL_DAYS: "Total days should not be more than 90 days",
  MAX_TEN_IMAGE: "Can upload only upto 10 Images",
  START_TIME: "Please enter valid start time",
  END_TIME: "Please enter valid end time",
  UPLOAD_DOCUMENT: "Please upload documents",
  DOWNLOAD_ERROR: "Error downloading file",
  DOWNLOADED_SUCCESSFULLY: "Document downloaded successfully",
  INVALID_DATES: "isseus with dates"
};
const ADD_SCHOOLS_ERROR_MESSAGES: any = {
  ONLY_NUMBERS: "Please enter a number",
  SCHOOL_NAME_REQUIRED: "Please enter the school name",
  FOUNDED_YEAR_REQUIRED: "Please enter the founded year",
  LOCATION_REQUIRED: "Please enter the location",
  CURRICULUM_REQUIRED: "Please enter the curriculum",
  SCHOOL_IMAGES_REQUIRED: "Please Upload the images of the school",
  WEBLINK_OF_SCHOOL_REQUIRED: "Please enter the web link of school",
  EMAIL_REQUIRED: "Please enter the email",
  INVALID_EMAIL: "Please enter a valid email",
  PHONE_NUMBER_REQUIRED: "Please enter the phone number",
  PRINCIPAL_REQUIRED: "Please enter the principal",
  GRADE_YEAR_REQUIRED: "Please enter the grade year",
  TUITION_FEES_REQUIRED: "Please enter the tuition fees",
  OPTIONAL_SERVICE_FEES_REQUIRED: "Please enter the optional service fees",
  ENROLLMENT_FEES_REQUIRED: "Please enter the enrollment fees",
  RE_ENROLLMENT_FEES_REQUIRED: "Please enter the re-enrollment fees",
  APPLICATION_FEES_REQUIRED: "Please enter the application fees",
  TOTAL_FEES_REQUIRED: "Please enter the total fees",
  DISCOUNT_ON_TUITION_FEES_REQUIRED:
    "Please enter the discount on tuition fees",
  START_OF_THE_ACADEMIC_YEAR_REQUIRED:
    "Please enter the start of the academic year",
  END_OF_THE_ACADEMIC_YEAR_REQUIRED:
    "Please enter the end of the academic year",
  INVALID_END_YEAR: "End year cannot be less than start year",
  INVALID_DATE: "End date cannot be less than start date",
  WINTER_BREAK_START_DATE_REQUIRED: "Please enter the winter break start date",
  WINTER_BREAK_END_DATE_REQUIRED: "Please enter the winter break end date",
  SPRING_BREAK_START_DATE_REQUIRED: "Please enter the spring break end date",
  SPRING_BREAK_END_DATE_REQUIRED: "Please enter the spring break end date",
  SUMMER_BREAK_START_DATE_REQUIRED: "Please enter the summer break start date",
  SUMMER_BREAK_END_DATE_REQUIRED: "Please enter the summer break end date",
  OTHER_HOLIDAYS_REQUIRED: "Please enter the other holidays",
  PUBLIC_HOLIDAYS_REQUIRED: "Please enter the public holidays",
  DSIB_INSPECTION_REPORT_REQUIRED: "Please enter the DSIB inspection report",
  DSIB_RATING_REQUIRED: "Please enter the DSIB rating",
};


const EDIT_UNIVERSITY_ERROR_MESSAGE: any = {
  UNIVERSITY_NAME: "Please enter the university name",
  QUALITY_ASSURANCE: "Please enter the Quality Assurance",
  LOCATION_REQUIRED: "Please enter the Location",
  WEBSITE_ADDRESS: "Please enter the Website link",
  WEBSITE_ADDRESS_CHECK: "Please enter valid URL",
  PRINCIPAL: "Please enter the principal name",
  EMAIL_REQUIRED: "Please enter a valid email",
  DEGREES_AND_FEES: "Please enter the degrees and fees",
  PROGRAMS_OFFERED: "Please enter programs offered",
  TEACHING_RATING: "Please enter teaching rating",
  EMPLOYABILITY_RATING: "Please enter the employability rating",
  RESEARCH: "Please enter the reaserch",
  RATING: "Please enter the rating",
  UNIVERSITY_IMAGES: "Please Upload the images of the university",
  INTERNATIONALIZATION_RATING: "Please enter the interntionalization rating",
  FACILITIES_RATING: "Please enter the facilities rating",
  PROGRAMME_STRENGTH_RATING: "Please enter the programme strength rating",
  INCLUSIVENESS_RATING: "Please enter the inclusiveness rating",
  ENVIRONMENTAL: "Please enter the environmental rating",
  IMPACT_RATING: "Please enter the impact rating",
  OVERALL_RATING: "Please enter the overall rating",
  NO_OF_STUDENTS: "Please enter the number of students",
  TOTAL_GRADUATES: "Please enter the total graduates",
  NO_OF_EMIRATES: "Please enter the number of emirates",
  STUDENTS: "Please enter the studente field",
  NO_OF_EXPATS: "Please enter the number of expacts",
  MALE: "Please enter the male count",
  FEMALE: "Please enter the female count",
  TRANSGENDER: "Please enter the transgender count",
  TOTAL_EDUCATORS: "Please enter the total educators",
  MAXIMUM_RATING: "Rating should be maximum 5",
  VALID_URL: "Please enter valid URL",
  IMAGE_LIMIT: "Should upload atleast 5 university images",
  VALID_FORMAT: "Please enter valid format",
  INVALID_PHONE_NUMBER: "Please enter valid phone number",
  PHONE_NUMBER_REQUIRED: "Please enter a phone number",
};

const REGISTRATION_ERRORS: any = {
  FIRST_NAME: "Please enter the first name",
  SCHOOL_NAME: "Please enter the school name",
  UNIVERSITY_NAME: "Please enter the university name",
  AUTHORITY_NAME: "Please enter the authority name",
  LAST_NAME: "Please enter the last name",
  ABOUT_ME: "Please enter about me field",
  ABOUT_CAMP: "Please enter about the camp field",
  GENDER_ERR: "Please select one of the genders",
  NATIONALITY: "Please enter the nationality",
  ADDRESS: "Please enter the address",
  CITY: "Please select the city",
  EMIRATE: "Please select the emirate",
  DISCRIPTION: "Please enter the description",
  STATE: "Please enter the state",
  PINCODE: "Please enter the pincode",
  DOB: "Please enter the date of birth",
  COUNTRY: "Please enter the country",
  COUNTRY_CODE: "Please enter the country code",
  LATITUDE: "Please enter the latitude",
  LONGITUDE: "Please enter the longitude",
  DEGREE: "Please enter the degree",
  SUBJECTS: "Please select subject",
  CURRICULUM: "Please select the curriculum",
  MODE_OF_TEACHING: "Please select the mode of teaching",
  EXPERIENCE: "Please enter the experience",
  SKILLS: "Please enter the skills",
  ROLE_SELECT: "Please select one of the roles to proceed further",
  EMIRATES_ID: "Please enter ID",
  VALID_EMIRATES_ID: "Please enter valid ID",
  IMMIGRANT_ID: "Please enter Immigrant ID",
  EMIRATES_FRONT: "Please upload ID -Front image",
  EMIRATES_BACK: "Please upload ID -Back image",
  IMMIGRANT_FRONT: "Please upload immigrant ID -Front image",
  IMMIGRANT_BACK: "Please upload immigrant ID -Back image",
  PROFILE_PHOTO: "Please upload profile photo",
  CERTIFICATE_UPLOAD: "Please upload certificate",
  TUTOR_CV: "Please upload CV",
  CAMP_NAME: "Please enter the camp name",
  TRAINER_QUALIFICATION: "Please enter the trainer qualification",
  ACTIVITIES_OFFERED: "Please select the activities offered",
  SPECIALIZATIONS: "Please add the specializations",
  CAMP_BROUCHER: "Please upload camp broucher",
  PDF_FORMAT: "Please upload only pdf format",
  CERTIFICATE_LIMIT: "Certificate Upload limit exceeded",
  SYLLABUS_LIMIT: "Syllabus file Upload limit exceeded",
  IMAGE_FORMAT: "Please upload in image format",
  UPLOADING_RESTRICTIONS: "Uploading file should less than 10MB in size",
  BANK_NAME: "Please enter the bank name",
  BANK_BRANCH_NAME: "Please enter the bank branch name",
  ACCOUNT_HOLDER_NAME: "Please enter the account holder name",
  ACCOUNT_NUMBER: "Please enter the account number",
  SWIFT_CODE: "Please enter the swift code",
  ADD_SUBJECT: "Please add atleast on subject",
  IBAN_ERROR: "Please enter the IBAN number",
  IBAN_VALIDATION: "Please enter valid IBAN number",
  ADD_ACTIVITY: "Please add atleast one activity",
  SESSION_VALID_DATE: "Please select valid date to create session",
  AUTHORITY_REQUIRED: "Please upload ID proof",
  CAMPSITE: "please enter site",
  TRADE_LICENCE: "please provide your trade licence ",
  TRADE_ID: "please provide your trade id ",

}

export { REGEX, ERROR_MESSAGES, ADD_SCHOOLS_ERROR_MESSAGES, REGISTRATION_ERRORS, EDIT_UNIVERSITY_ERROR_MESSAGE };
